module.exports = __webpack_public_path__ + "img/lunbo41.b2cdf51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/lunbo41.png
// module id = lLXW
// module chunks = 0